export default __webpack_public_path__ + "locales/bg/Webhooks.json?hash=6e2e048bf569de803bf4323a0be68a32";